import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import Typography from 'material-ui/Typography';
import LetterOrderProgress from "../../Timeline/parts/LetterOrderProgress";
import { isDisplayFollowCallExist } from '../../../utils/orderUtils';
import { connect } from 'react-redux';
import moment from "moment";

const styles = () => ({
  progressArea: {
    display: "flex",
    marginBottom: 5,
    alignItems: 'center',
  },

  link: {
    color: "#1A65FF",
    textDecoration: 'underline',
    marginRight: 20,
    cursor: 'pointer',
    whiteSpace: 'nowrap',
  },

  caption: {
    marginRight: 10,
  },

  call: {
    color: "#707070",
    background: "#FFFFFF",
    display: "inline-block",
    padding: "5px",
    fontSize: "11px",
    margin: "5px 0",
    fontWeight: "bold",
  },
});

class ItemDetails extends React.Component {

  isDelayLetterOrder = (letterOrder) => {
    if (letterOrder && letterOrder.shipped_at) {
      return false;
    }

    if (moment(letterOrder.shipping_scheduled_at).format("YYYY-MM-DD") < moment().format("YYYY-MM-DD")) {
      return true;
    }

    return false;
  }

  render() {
    const { classes, item, user } = this.props;

    const target = (item.letter_order) ? item.letter_order : item.follow_call_order;
    const isOrderedLetter = item.letter_order ? true : false;
    const isOrderedFollowCall = item.follow_call_order ? true : false;
    const isExe = isOrderedLetter && item.letter_order.latest_order_address && item.letter_order.latest_order_address.executive_person_id ? true : false;
    const trackingUrl = isOrderedLetter && item.letter_order.letter_tracking_urls && item.letter_order.letter_tracking_urls.length > 0 ? item.letter_order.letter_tracking_urls[0].tracking_url : "";

    return (
      <React.Fragment>
        {isDisplayFollowCallExist(item, user) && (
          <div className={classes.call} style={isOrderedFollowCall ? { color: this.props.callFontColor, background: this.props.callBackground } : {}}>
            <span>フォローコール{isOrderedFollowCall ? 'あり' : 'なし'}</span>
          </div>
        )}

        <div className={classes.progressArea}>
          <Typography variant="body1" style={{ marginRight: 10 }}> {isOrderedLetter ? "レター注文" : "フォローコール注文"}No.{target.id}</Typography>
          {target.latest_timeline_status && (
            <LetterOrderProgress status={target.latest_timeline_status} />
          )}
        </div>

        {isOrderedLetter && (
          <Typography variant="body1" style={{ fontSize: 11, marginBottom: "5px", color: (this.isDelayLetterOrder(item.letter_order)) ? "red" : "" }}>
            {moment(item.letter_order.shipping_scheduled_at).format("YYYY/MM/DD")}発送予定
            {this.isDelayLetterOrder(item.letter_order) && (
              <span style={{ marginLeft: "10px" }}>申し訳ございません。注文が混雑しておりレターの発送が遅延しております。</span>
            )}
          </Typography>
        )}
        <Typography variant="caption" style={{ fontSize: 9, color: "#71737B" }}>
          {target.latest_order_address && (
            <span className={classes.caption}>
              {target.order_contact ? target.order_contact.name + 'さんが' : ''}{isExe ? "キーマンデータベース" : "自社リスト"}から注文
            </span>
          )}
          {isOrderedLetter && (
            <React.Fragment>
              <span className={classes.caption}>
                親展マーク{target.shinten_mark_flag ? "有り" : "無し"}{target.registered_letter_flag ? "・書留利用" : ""}
              </span>
              <span className={classes.caption}>
                差出人情報：{target.sender_name} {target.sender_post_code} {target.sender_address}
              </span>
              <span className={classes.caption}>
                {target.original_letter_format_flag ? "別途納品したレターフォーマットを利用" : "キーマンレターのレターフォーマットを利用"}
              </span>
            </React.Fragment>
          )}
        </Typography>

        {trackingUrl && (
          <Typography variant="body1" style={{ marginTop: 5 }}> QRコードURL：
            <a className={classes.link} target="_blank" href={trackingUrl}>{trackingUrl}</a>
          </Typography>
        )}
      </React.Fragment>
    )
  }
}

ItemDetails.defaultProps = {
  callFontColor: '#FFFFFF',
  callBackground: '#195AFF',
}

ItemDetails.propTypes = {
  classes: PropTypes.object.isRequired,
  item: PropTypes.object,
  user: PropTypes.object,
  callFontColor: PropTypes.string,
  callBackground: PropTypes.string,
};

const mapStateToProps = (state) => {
  return {
    user: state.accountSetting.user,
  };
};

export default withStyles(styles)(connect(
  mapStateToProps
)(ItemDetails));



// WEBPACK FOOTER //
// ./src/components/OrderList/parts/ItemDetails.jsx